import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { socket } from "../../../services/socket/socket";
import { useEffect } from "react";
import {
  UpdatePreset,
  getProjectsConsol,
} from "../../../Console/Component/services/apiHandler";
import { getAllConsolForConsol, saveinvesteechange } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { useState } from "react";
import AssociateBrowseModal from "../../../Console/Component/modal/associateModal";
import { useDispatch, useSelector } from "react-redux";
import { setAllChecksPreset } from "../../../redux/actions/actionPreset";
import { fetchPrepareConsoleData } from "../../../redux/actions/actionPrepareConsole";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchSubsidiaryConsoleData } from "../../../redux/actions/actionSubsidiaryData";
import Loader from "../../../helper/loader";



import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import Dropdown from "../../../myfin_v2/elements/Dropdownnew";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CheckIcon } from "../../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as ErrorIcon } from "../../../myfin_v2/assets/icons/warningred.svg";

const style_v2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1400,
  height: 670,
  bgcolor: "background.paper",
  outline: "none",
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 4,
};
// const label = { inputProps: { "aria-label": "Checkbox demo" } };

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Top-level selection mode constants
const MODE_UPLOAD_PRESET = "upload_preset";
const MODE_SELECT_CONSOL_FS = "select_consol_fs";

// Per-row select option constants
const SELECT_OPTION_STANDALONE = "Standalone";
const SELECT_OPTION_CONSOL_FS = "Consol FS";

const SubsidiarySelectModal = (props) => {
  const {
    isopen,
    handleIsClose,
    handleChange,
    workspaceData,
    presetIdData,
    CompanyName,
    prepareConsoleId
  } = props;
  const [openassociate, setOpenAssociate] = useState(false);
  const [associateId, setAssociateId] = useState("");
  const [consoldata, setConsolData] = useState([]);
  const [projectsData, setProjectsData] = useState([]);
  const [allcheckdata, setAllcheckData] = useState([]);
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectCheckDataAssociate, setSelectCheckDataAssociate] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedParentPreset, setSelectedParentPreset] = useState("");
  // const [tableData, SetInvestmentRegister] = useState([]);
  const [fieldOfIr, setFieldOfIr] = useState("");
  const subsidiaryData = useSelector((state) => state.SubsidiaryConsoleReducer);
  const [investeeData, setInvesteeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const prepareConsoleData = useSelector(
    (state) => state.PrepareConsoleReducer
  );

  // NEW: top-level mode and consol list state
  const [topLevelMode, setTopLevelMode] = useState(MODE_UPLOAD_PRESET);
  const [selectedTopLevelValue, setSelectedTopLevelValue] = useState("");
  const [allConsolList, setAllConsolList] = useState([]);

  const investeeOptions = investeeData.map((inv) => ({
    label: inv?.investeeCompanyData?.company_name,
    value: inv?.investeeCompanyID,
  }));

  const presetOptions = projectsData.map((proj) => ({
    label: proj.project_name,
    value: proj._id,
  }));

  // NEW: consol FS options from getAllConsol API
  const consolFSOptions = allConsolList.map((consol) => ({
    label: consol.name,
    value: consol._id,
  }));

  const { prepareConsole } = useSelector((state) => state.miscellaneousReducer);

  const dispatch = useDispatch();

const handleSaveChanges = async () => {
  const consolId = prepareConsoleId || prepareConsole?._id;

  if (!consolId) {
    console.error("No valid consolId found:", { prepareConsoleId, prepareConsole });
    return;
  }

  // UPDATED: include FSType and consolID in payload
  const isConsolMode = topLevelMode === MODE_SELECT_CONSOL_FS;

  const payload = {
    standaloneID: isConsolMode ? null : selectedTopLevelValue,
    consolID: isConsolMode ? selectedTopLevelValue : null,
    FSType: isConsolMode ? "consol" : "standalone",
    investeeConfigs: investeeData.map((item) => {
      const rowOption = item.selectOption ||
        (item.FSType === "consol" || item.selectedConsolID
          ? SELECT_OPTION_CONSOL_FS
          : SELECT_OPTION_STANDALONE);
      return {
        investeeCompanyID: item.investeeCompanyID,
        selectedStandaloneID: rowOption === SELECT_OPTION_CONSOL_FS ? null : (item.selectedStandaloneID || item.investeeCompanyID),
        selectedConsolID: rowOption === SELECT_OPTION_CONSOL_FS ? (item.selectedConsolID || null) : null,
        FSType: rowOption === SELECT_OPTION_CONSOL_FS ? "consol" : "standalone",
        validationCheck: item.validationCheck,
        addToParentFS: item.addToParentFS,
      };
    }),
  };

  try {
    const res = await saveinvesteechange(consolId, payload);
    console.log("Save response:", res);
    if (res?.data?.success) {
      handleIsClose();
    }
  } catch (err) {
    console.error("Save failed:", err);
  }
};

// ✅ FIX: Both API calls are awaited together using Promise.all so that
// projectsData (presetOptions) is always populated before selectedParentPreset
// is set, eliminating the race condition that caused the default value not to show.
const fetchConsolData = async () => {
  try {
    setLoading(true);

    const workspace_id = workspaceData[0]?._id;

    const [consolRes, projectsRes, allConsolRes] = await Promise.all([
      getAllConsolForConsol(workspace_id),
      getProjectsConsol(workspace_id),
      getAllConsolForConsol(workspace_id),
    ]);

    if (projectsRes?.data?.project) {
      setProjectsData(projectsRes.data.project);
    }

    // NEW: populate consol list
    if (allConsolRes?.data?.consolList) {
      setAllConsolList(allConsolRes.data.consolList);
    }

    if (consolRes?.data?.success) {
      const currentConsol = consolRes.data.consolList.find(
        (consol) => consol._id === presetIdData
      );
      setInvesteeData(currentConsol?.investeeList || []);

      // NEW: determine initial top-level mode from saved FSType/consolID
      if (currentConsol?.FSType === "consol" && currentConsol?.consolID) {
        setTopLevelMode(MODE_SELECT_CONSOL_FS);
        setSelectedTopLevelValue(currentConsol.consolID);
      } else {
        setTopLevelMode(MODE_UPLOAD_PRESET);
        setSelectedTopLevelValue(currentConsol?.standaloneID || "");
        setSelectedParentPreset(currentConsol?.standaloneID || "");
      }
    }

  } catch (err) {
    console.log("Consol Fetch Error:", err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
  if (isopen && workspaceData?.length > 0) {
    fetchConsolData();
  }
}, [isopen]);


  useEffect(() => {
    if (subsidiaryData.isSuccess && prepareConsoleData.isSuccess) {
      let resultSet = [];
      subsidiaryData.response.otherData.forEach((subsidiary) => {
        let consolidation = prepareConsoleData?.response?.getOnePreCompany[0]?.consolidation;
        const exist = consolidation.find(
          (consol) => consol.Ir_id === subsidiary._id
        );
        if (exist) {
          resultSet.push(exist)
        }
      })
      setSelectCheckData(resultSet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subsidiaryData, prepareConsoleData])

  const browseConsol = (project_id, field) => {
    setAssociateId(project_id);
    setOpenAssociate(true);
    setFieldOfIr(field);
  };
  const handleClose = () => {
    setOpenAssociate(false);
  };
  const uploadPresetToSubsidiary = (project_id, prepare_console_id, field) => {

  const consoleData = prepareConsoleData?.response?.getOnePreCompany?.[0];
  if (!consoleData) return;

  if (field === "Subsidiary") {

    const objIndex =
      consoleData?.subsidiary_upload_preset?.findIndex(
        (data) => data.prepare_console_id === prepare_console_id
      );
      if (objIndex === -1) {
        prepareConsoleData?.response?.getOnePreCompany[0]?.subsidiary_upload_preset.push(
          {
            project_id: project_id,
            prepare_console_id: prepare_console_id,
          }
        );
      } else {
        prepareConsoleData.response.getOnePreCompany[0].subsidiary_upload_preset[
          objIndex
        ]["project_id"] = project_id;
      }
      setConsolData(prepareConsoleData?.response?.getOnePreCompany[0]);
      dispatch(fetchPrepareConsoleData(prepareConsole._id));
    } else {
      const objIndex =
        prepareConsoleData?.response?.getOnePreCompany[0]?.associate_upload_preset?.findIndex(
          (data) => data.prepare_console_id === prepare_console_id
        );
      if (objIndex === -1) {
        prepareConsoleData?.response?.getOnePreCompany[0]?.associate_upload_preset.push(
          {
            project_id: project_id,
            prepare_console_id: prepare_console_id,
          }
        );
      } else {
        prepareConsoleData.response.getOnePreCompany[0].associate_upload_preset[
          objIndex
        ]["project_id"] = project_id;
      }
      setConsolData(prepareConsoleData?.response?.getOnePreCompany[0]);
    }
  };
 const getCompanyData = async () => {
  try {
    const response = await getProjectsConsol(workspaceData[0]?._id);

    console.log(response.data);

    setProjectsData(response.data.project);
  } catch (err) {
    console.log("err", err.response);
  }
};
  const getProjectName = (p_id) => {
    try {
      if (!p_id) return "";
      const nameOfType = projectsData.filter((adj) => adj._id === p_id);
      const result = nameOfType[0]?.project_name
        ? nameOfType[0]?.project_name
        : "";
      return result;
    } catch (err) {
      console.log("err", err.message);
    }
  };
 const newGetProjectName = (subsidiary_id, getId = false) => {
  try {
    const consoleData = prepareConsoleData?.response?.getOnePreCompany;

    if (!consoleData || consoleData.length === 0) return "";

    const subsidiary_upload_preset = consoleData[0]?.subsidiary_upload_preset;

    if (!subsidiary_upload_preset) return "";

    const projectData = subsidiary_upload_preset.find(
      (obj) => obj?.prepare_console_id === subsidiary_id
    );

    if (!projectData) return "";

    if (getId) {
      return projectData.project_id;
    }

    return getProjectName(projectData.project_id);
  } catch (err) {
    console.log("Project Name Error:", err.message);
    return "";
  }
};

  const consolidateChange = (e, data, project_id, field) => {
  const checked = e.target.checked;

  setInvesteeData((prev) =>
    prev.map((item) =>
      item.investeeCompanyID === data.investeeCompanyID
        ? { ...item, addToParentFS: checked }
        : item
    )
  );

  if (field === "Subsidiary") {
    if (checked) {
      let dataValue = {
        all_data: data,
        project_id: project_id,
      };

      setAllcheckData(prev => [...prev, dataValue]);

      let checkData = {
        Ir_id: data._id,
        project_id: project_id,
      };

      setSelectCheckData(prev => [...prev, checkData]);
    } else {
      setAllcheckData(prev =>
        prev.filter((item) => item.all_data._id !== data._id)
      );

      setSelectCheckData(prev =>
        prev.filter((item) => item.Ir_id !== data._id)
      );
    }
  } else {
    if (checked) {
      let checkData = {
        Ir_id: data._id,
        project_id: project_id,
      };

      setSelectCheckDataAssociate(prev => [
        ...prev,
        checkData,
      ]);
    } else {
     setSelectCheckDataAssociate(prev =>
      prev.filter((item) => item.Ir_id !== data._id)
    );
    }
  }
};
  const saveModalCheck = async () => {
    let data = {
      Consolidate: selectCheckData,
      AssociateConsolidate: selectCheckDataAssociate
    };
    const res = await UpdatePreset(data, prepareConsole._id);
    dispatch(fetchPrepareConsoleData(presetIdData));

    if (res.status === 200) {
      socket.emit("request-prepare-console", {
        prepare_console_id: prepareConsole._id,
      });
      dispatch(setAllChecksPreset(selectCheckData));
      handleIsClose();
    }
  };

  const checkConsolidated = (ir_id) => {
    try {
      const exist =
        prepareConsoleData?.response?.getOnePreCompany[0]?.consolidation.find(
          (consol) => consol.Ir_id === ir_id
        );
      if (exist) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("error", err.message);
      return false;
    }
  };

  const checkConsolidatedAssociate = (ir_id) => {
    try {
      const exist =
        prepareConsoleData?.response?.getOnePreCompany[0]?.AssociateConsolidate.find(
          (consol) => consol.Ir_id === ir_id
        );
      if (exist) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("error", err.message);
      return false;
    }
  }

  // NEW: per-row select option change handler
  const handleRowSelectOptionChange = (investeeCompanyID, optionValue) => {
    setInvesteeData((prev) =>
      prev.map((item) =>
        item.investeeCompanyID === investeeCompanyID
          ? {
              ...item,
              selectOption: optionValue,
              selectedStandaloneID: optionValue === SELECT_OPTION_STANDALONE ? item.selectedStandaloneID : null,
              selectedConsolID: optionValue === SELECT_OPTION_CONSOL_FS ? item.selectedConsolID : null,
            }
          : item
      )
    );
  };

  const formatIndianCurrency = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const amount = Number(val);
    const formatted = Math.abs(amount).toLocaleString("en-IN");
    return amount < 0 ? `(${formatted})` : formatted;
  };

  useEffect(() => {
    console.log("value", value);

  }, [value])
  return (
    <>
      {isopen && (
        <Modal
          title="Investees"
          bodycss={commoncss.unsetPadding}
          width="75%"
          headerActions={
            <CloseIcon
              onClick={handleIsClose}
              className="clickable"
            />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleIsClose}
                label="Cancel"
              />

             <Button
              btnColor={buttoncss.primary}
              label="Save Changes"
              onClick={handleSaveChanges}
            />
            </>
          }
        >
          <div className={commoncss.pd1530}>

            {/* UPDATED: replaced single dropdown with "Select an option" + radio buttons + conditional dropdown */}
            <div style={{ marginBottom: "20px" }}>
              {/* Row: label on left, radio buttons on right */}
              <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                <span style={{ fontWeight: 500, fontSize: "14px", whiteSpace: "nowrap" }}>
                  Select an option
                </span>
                <div style={{ display: "flex", alignItems: "center", gap: "20px", marginLeft: "auto" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    <input
                      type="radio"
                      name="topLevelMode"
                      value={MODE_UPLOAD_PRESET}
                      checked={topLevelMode === MODE_UPLOAD_PRESET}
                      onChange={() => {
                        setTopLevelMode(MODE_UPLOAD_PRESET);
                        setSelectedTopLevelValue("");
                      }}
                      style={{ accentColor: "#205a46" }}
                    />
                    UPLOAD PRESET
                  </label>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    <input
                      type="radio"
                      name="topLevelMode"
                      value={MODE_SELECT_CONSOL_FS}
                      checked={topLevelMode === MODE_SELECT_CONSOL_FS}
                      onChange={() => {
                        setTopLevelMode(MODE_SELECT_CONSOL_FS);
                        setSelectedTopLevelValue("");
                      }}
                      style={{ accentColor: "#205a46" }}
                    />
                    SELECT EXISTING CONSOL FS
                  </label>
                </div>
              </div>

              {/* Conditional dropdown below radio buttons */}
              {topLevelMode === MODE_UPLOAD_PRESET ? (
                <Dropdown style2={{ width: "250px", boxSizing: "border-box" }}
                  placeHolder="Select preset"
                  options={presetOptions}
                  selValue={selectedTopLevelValue}
                  onSelect={(val) => {
                    setSelectedTopLevelValue(val?.value);
                    setSelectedParentPreset(val?.value);
                  }}
                />
              ) : (
                <Dropdown style2={{ width: "250px", boxSizing: "border-box" }}
                  placeHolder="Select Consol FS"
                  options={consolFSOptions}
                  selValue={selectedTopLevelValue}
                  onSelect={(val) => setSelectedTopLevelValue(val?.value)}
                />
              )}
            </div>

            <div className={commoncss.bdrBr}>
              <div style={{ "border-bottom": "1px solid #eaeeed" }}>
                <button
                  className={`tab-button ${value === 0 ? "active" : ""}`}
                  onClick={() => {
                    setValue(0);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset", "border-top-left-radius": "10px" }}
                >
                  Subsidiary
                </button>
                <button
                  className={`tab-button ${value === 1 ? "active" : ""}`}
                  onClick={() => {
                    setValue(1);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset" }}
                >
                  Joint ventures
                </button>
                <button
                  className={`tab-button ${value === 2 ? "active" : ""}`}
                  onClick={() => {
                    setValue(2);
                  }}
                  style={{ textTransform: "capitalize", borderBottom: "unset" }}
                >
                  Associate
                </button>
                <button
                  className={`tab-button ${value === 3 ? "active" : ""}`}
                  onClick={() => {
                    setValue(3);
                  }}
                  style={{ "text-transform": "capitalize", "border-bottom": "unset" }}
                >
                  Investments
                </button>
              </div>
              <CustomTabPanel
                value={value}
                index={0}
              >
                <div className={standalonecss.standaloneTableContainer} style={{ height: "50vh" }}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT OPTION</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>

                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7">
                          <div
                            style={{
                              height: "300px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Loader />
                          </div>
                        </td>
                      </tr>
                    ) : investeeData.length > 0 ? (
                      investeeData
                        .filter(
                          (item) => item.natureOfRelationship === "Subsidiary"
                        )
                        .map((subsiary, key) => {
                         const currentSelectOption =
                            subsiary.selectOption ??
                            (subsiary.FSType === "consol" || subsiary.selectedConsolID
                              ? SELECT_OPTION_CONSOL_FS
                              : SELECT_OPTION_STANDALONE);
                          return (
                          <tr key={subsiary.investeeCompanyID}>
                            <td>
                              {subsiary?.investeeCompanyData?.company_name}
                            </td>

                            <td className={commoncss.p12_5} style={{ textAlign: "right", paddingRight: "40px" }}>
                              {formatIndianCurrency(subsiary?.investmentValue)}
                            </td>

                            <td className={commoncss.p12_5} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>
                              {subsiary?.holdingPercentage}
                            </td>

                            {/* NEW: SELECT OPTION column */}
                            <td className={`${commoncss.p12_5} text-center`}>
                              <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                placeHolder="Select Option"
                                options={[
                                  { label: "Standalone", value: SELECT_OPTION_STANDALONE },
                                  { label: "Consol FS", value: SELECT_OPTION_CONSOL_FS }
                                ]}
                                selValue={currentSelectOption}
                                onSelect={(val) =>
                                  handleRowSelectOptionChange(
                                    subsiary.investeeCompanyID,
                                    val?.value
                                  )
                                }
                              />
                            </td>

                            <td className={`${commoncss.p12_5} text-center`}>
                              <span
                                className={commoncss.dFlexClm}
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  overflow: "visible"
                                }}
                              >
                              {/* UPDATED: show consol FS dropdown or preset dropdown based on selectOption */}
                              {currentSelectOption === SELECT_OPTION_CONSOL_FS ? (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={consolFSOptions}
                                  selValue={subsiary.selectedConsolID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === subsiary.investeeCompanyID
                                          ? { ...item, selectedConsolID: val?.value }
                                          : item
                                      )
                                    );
                                  }}
                                />
                              ) : (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={presetOptions}
                                  selValue={subsiary.selectedStandaloneID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === subsiary.investeeCompanyID
                                          ? { ...item, selectedStandaloneID: val?.value }
                                          : item
                                      )
                                    );
                                    uploadPresetToSubsidiary(val?.value, subsiary.investeeCompanyID, "Subsidiary");
                                  }}
                                />
                              )}
                                <span>{newGetProjectName(subsiary.investeeCompanyID)}</span>
                              </span>
                            </td>



                           <td
                            className={`${commoncss.p12_5} text-center`}
                            onClick={() =>
                              consolidateChange(
                                { target: { checked: !subsiary.addToParentFS } },
                                subsiary,
                                newGetProjectName(subsiary.investeeCompanyID, true),
                                "Subsidiary"
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <Checkbox
                              checked={subsiary.addToParentFS}
                              onChange={(e) =>
                                consolidateChange(
                                  e,
                                  subsiary,
                                  newGetProjectName(subsiary.investeeCompanyID, true),
                                  "Subsidiary"
                                )
                              }
                              sx={{
                                color: "#C2E6D1",
                                "&.Mui-checked": {
                                  color: "#205a46",
                                }
                              }}
                            />
                          </td>
                          </tr>
                          );
                        })
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                    
                  </table>
                </div>
              </CustomTabPanel>
              <CustomTabPanel
                value={value}
                style={{ marginTop: "10px" }}
                index={1}
              >

                <div className={standalonecss.standaloneTableContainer} style={{ height: "50vh" }}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT OPTION</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>

                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    <tbody>
                    {investeeData.length > 0 ? (
                      investeeData
                        .filter(
                          (item) =>
                            item.holdingPercentage >= 20 &&
                            item.holdingPercentage <= 50 &&
                            item.natureOfRelationship === "Joint Venture"
                        )
                        .map((subsiary, key) => {
                          const currentSelectOption =
                            subsiary.selectOption ??
                            (subsiary.FSType === "consol" || subsiary.selectedConsolID
                              ? SELECT_OPTION_CONSOL_FS
                              : SELECT_OPTION_STANDALONE);
                          return (
                          <tr key={subsiary.investeeCompanyID}>
                            <td>
                              {subsiary?.investeeCompanyData?.company_name}
                            </td>

                            <td className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>
                              {formatIndianCurrency(subsiary?.investmentValue)}
                            </td>

                            <td className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>
                              {subsiary?.holdingPercentage}
                            </td>

                            <td className={`${commoncss.p12_5} text-center`}>
                              <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                placeHolder="Select Option"
                                options={[
                                  { label: "Standalone", value: SELECT_OPTION_STANDALONE },
                                  { label: "Consol FS", value: SELECT_OPTION_CONSOL_FS }
                                ]}
                                selValue={currentSelectOption}
                                onSelect={(val) =>
                                  handleRowSelectOptionChange(
                                    subsiary.investeeCompanyID,
                                    val?.value
                                  )
                                }
                              />
                            </td>

                            <td className={`${commoncss.p12_5} text-center`}>
                              <span
                              className={commoncss.dFlexClm}
                              style={{
                                position: "relative",
                                display: "inline-block",
                                overflow: "visible"
                              }}
                            >
                            {/* UPDATED: show consol FS dropdown or preset dropdown based on selectOption */}
                            {currentSelectOption === SELECT_OPTION_CONSOL_FS ? (
                              <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                placeHolder="Selection"
                                options={consolFSOptions}
                                selValue={subsiary.selectedConsolID}
                                onSelect={(val) => {
                                  setInvesteeData(prev =>
                                    prev.map(item =>
                                      item.investeeCompanyID === subsiary.investeeCompanyID
                                        ? { ...item, selectedConsolID: val?.value }
                                        : item
                                    )
                                  );
                                }}
                              />
                            ) : (
                              <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                placeHolder="Selection"
                                options={presetOptions}
                                selValue={subsiary.selectedStandaloneID}
                                onSelect={(val) => {
                                  setInvesteeData(prev =>
                                    prev.map(item =>
                                      item.investeeCompanyID === subsiary.investeeCompanyID
                                        ? { ...item, selectedStandaloneID: val?.value }
                                        : item
                                    )
                                  );
                                  uploadPresetToSubsidiary(val?.value, subsiary.investeeCompanyID, "Joint Venture");
                                }}
                              />
                            )}
                                <span>{newGetProjectName(subsiary.investeeCompanyID)}</span>
                              </span>
                            </td>



                            <td
                              className={`${commoncss.p12_5} text-center`}
                              onClick={() =>
                                consolidateChange(
                                  { target: { checked: !subsiary.addToParentFS } },
                                  subsiary,
                                  newGetProjectName(subsiary.investeeCompanyID, true),
                                  "Joint Venture"
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <Checkbox
                                checked={subsiary.addToParentFS}
                                onChange={(e) =>
                                  consolidateChange(
                                    e,
                                    subsiary,
                                    newGetProjectName(subsiary.investeeCompanyID, true),
                                    "Joint Venture"
                                  )
                                }
                                sx={{
                                  color: "#C2E6D1",
                                  "&.Mui-checked": {
                                    color: "#205a46",
                                  },
                                }}
                              />
                            </td>
                          </tr>
                          );
                        })
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No Data Available 
                        </td>
                      </tr>
                    )}
                  </tbody>
                  </table>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <div className={standalonecss.standaloneTableContainer} style={{ height: "50vh" }}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th>INVEST REGISTER NAME</th>
                        <th className={commoncss.p12_5} style={{ textAlign: "right", paddingRight: "40px" }}>INVESTMENT VALUE</th>
                        <th className={commoncss.p12_5} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>
                          SELECT OPTION
                        </th>
                        <th className={`${commoncss.p12_5} text-center`}>
                          SELECT PRESET
                        </th>

                        <th className={`${commoncss.p12_5} text-center`}>
                          ADD TO PARENT FS
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {investeeData.length > 0 ? (
                        investeeData
                          .filter(
                            (item) =>
                              item.holdingPercentage >= 20 &&
                              item.holdingPercentage <= 50 &&
                              item.natureOfRelationship === "Associate"
                          )
                          .map((associate, key) => {
                           const currentSelectOption =
                            associate.selectOption ??
                            (associate.FSType === "consol" || associate.selectedConsolID
                              ? SELECT_OPTION_CONSOL_FS
                              : SELECT_OPTION_STANDALONE);
                            return (
                            <tr key={associate.investeeCompanyID}>
                              <td>{associate?.investeeCompanyData?.company_name}</td>

                              <td className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>
                                {formatIndianCurrency(associate?.investmentValue)}
                              </td>

                              <td className={commoncss.p12_5} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>
                                {associate?.holdingPercentage}
                              </td>

                              {/* NEW: SELECT OPTION column */}
                              <td className={`${commoncss.p12_5} text-center`}>
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Select Option"
                                  options={[
                                    { label: "Standalone", value: SELECT_OPTION_STANDALONE },
                                    { label: "Consol FS", value: SELECT_OPTION_CONSOL_FS }
                                  ]}
                                  selValue={currentSelectOption}
                                  onSelect={(val) =>
                                    handleRowSelectOptionChange(
                                      associate.investeeCompanyID,
                                      val?.value
                                    )
                                  }
                                />
                              </td>

                              <td className={`${commoncss.p12_5} text-center`}>
                              {/* UPDATED: show consol FS dropdown or preset dropdown based on selectOption */}
                              {currentSelectOption === SELECT_OPTION_CONSOL_FS ? (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={consolFSOptions}
                                  selValue={associate.selectedConsolID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === associate.investeeCompanyID
                                          ? { ...item, selectedConsolID: val?.value }
                                          : item
                                      )
                                    );
                                  }}
                                />
                              ) : (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={presetOptions}
                                  selValue={associate.selectedStandaloneID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === associate.investeeCompanyID
                                          ? { ...item, selectedStandaloneID: val?.value }
                                          : item
                                      )
                                    );
                                    uploadPresetToSubsidiary(val?.value, associate.investeeCompanyID, "Associate");
                                  }}
                                />
                              )}
                              </td>



                            <td
                            className={`${commoncss.p12_5} text-center`}
                            onClick={() =>
                              consolidateChange(
                                { target: { checked: !associate.addToParentFS } },
                                associate,
                                newGetProjectName(associate.investeeCompanyID, true),
                                "Associate"
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <Checkbox
                              checked={associate.addToParentFS}
                              onChange={(e) =>
                                consolidateChange(
                                  e,
                                  associate,
                                  newGetProjectName(associate.investeeCompanyID, true),
                                  "Associate"
                                )
                              }
                            />
                          </td>
                            </tr>
                            );
                          })
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center" }}>
                            No Associate Data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </CustomTabPanel>
              <CustomTabPanel
                value={value}
                style={{ marginTop: "10px" }}
                index={3}
              >

                <div className={standalonecss.standaloneTableContainer} style={{ height: "50vh" }}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th className={``}>INVEST REGISTER NAME</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>INVESTMENT VALUE</th>
                        <th className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>HOLDING %</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT OPTION</th>
                        <th className={`${commoncss.p12_5} text-center`}>SELECT PRESET</th>

                        <th className={`${commoncss.p12_5} text-center`}>ADD TO PARENT FS</th>
                      </tr>
                    </thead>
                    <tbody>
                    {investeeData.length > 0 ? (
                      investeeData
                        .filter(
                          (item) =>
                            item.holdingPercentage < 20 &&
                            item.natureOfRelationship === "Investment"
                        )
                        .map((subsiary, key) => {
                         const currentSelectOption =
                          subsiary.selectOption ??
                          (subsiary.FSType === "consol" || subsiary.selectedConsolID
                            ? SELECT_OPTION_CONSOL_FS
                            : SELECT_OPTION_STANDALONE);
                          return (
                         <tr key={subsiary.investeeCompanyID}>
                            <td>
                              {subsiary?.investeeCompanyData?.company_name}
                            </td>

                            <td className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingRight: "40px" }}>
                              {formatIndianCurrency(subsiary?.investmentValue)}
                            </td>

                            <td className={`${commoncss.p12_5}`} style={{ textAlign: "right", paddingLeft: "40px", paddingRight: "40px" }}>
                              {subsiary?.holdingPercentage}
                            </td>

                            {/* NEW: SELECT OPTION column */}
                            <td className={`${commoncss.p12_5} text-center`}>
                              <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                placeHolder="Select Option"
                                options={[
                                  { label: "Standalone", value: SELECT_OPTION_STANDALONE },
                                  { label: "Consol FS", value: SELECT_OPTION_CONSOL_FS }
                                ]}
                                selValue={currentSelectOption}
                                onSelect={(val) =>
                                  handleRowSelectOptionChange(
                                    subsiary.investeeCompanyID,
                                    val?.value
                                  )
                                }
                              />
                            </td>

                            <td className={`${commoncss.p12_5} text-center`}>
                             <span
                              className={commoncss.dFlexClm}
                              style={{
                                position: "relative",
                                display: "inline-block",
                                overflow: "visible"
                              }}
                            >
                              {/* UPDATED: show consol FS dropdown or preset dropdown based on selectOption */}
                              {currentSelectOption === SELECT_OPTION_CONSOL_FS ? (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={consolFSOptions}
                                  selValue={subsiary.selectedConsolID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === subsiary.investeeCompanyID
                                          ? { ...item, selectedConsolID: val?.value }
                                          : item
                                      )
                                    );
                                  }}
                                />
                              ) : (
                                <Dropdown style2={{ width: "250px", boxSizing: "border-box", margin: "0 auto" }}
                                  placeHolder="Selection"
                                  options={presetOptions}
                                  selValue={subsiary.selectedStandaloneID}
                                  onSelect={(val) => {
                                    setInvesteeData(prev =>
                                      prev.map(item =>
                                        item.investeeCompanyID === subsiary.investeeCompanyID
                                          ? { ...item, selectedStandaloneID: val?.value }
                                          : item
                                      )
                                    );
                                    uploadPresetToSubsidiary(val?.value, subsiary.investeeCompanyID, "Investment");
                                  }}
                                />
                              )}
                                <span>{newGetProjectName(subsiary.investeeCompanyID)}</span>
                              </span>
                            </td>



                            <td
                            className={`${commoncss.p12_5} text-center`}
                            onClick={() =>
                              consolidateChange(
                                { target: { checked: !subsiary.addToParentFS } },
                                subsiary,
                                newGetProjectName(subsiary.investeeCompanyID, true),
                                "Investment"
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <Checkbox
                              checked={subsiary.addToParentFS}
                              onChange={(e) =>
                                consolidateChange(
                                  e,
                                  subsiary,
                                  newGetProjectName(subsiary.investeeCompanyID, true),
                                  "Investment"
                                )
                              }
                              sx={{
                                color: "#C2E6D1",
                                "&.Mui-checked": {
                                  color: "#205a46",
                                },
                              }}
                            />
                          </td>
                          </tr>
                          );
                        })
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  </table>
                </div>
              </CustomTabPanel>
            </div>
          </div>
        </Modal>
      )}

      {openassociate && (
        <AssociateBrowseModal
          handleClose={handleClose}
          open={openassociate}
          selectedAssociateId={associateId}
          setPresetHandler={uploadPresetToSubsidiary}
          projectsData={projectsData}
          prepareConsoleId={presetIdData}
          nature={fieldOfIr}
          workspaceData={workspaceData}
          consoldata={consoldata}
        />

      )}
    </>
  );
};

export default SubsidiarySelectModal;

const CheckBoxComp = (props) => {
  const {
    label,
    consolidated,
    consolidateChange,
    filteredName,
    newGetProjectName,
    field
  } = props;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(consolidated);
  }, [consolidated]);

  const handleChange = (event, field) => {
    setChecked(event.target.checked);
    consolidateChange(
      event,
      filteredName,
      newGetProjectName(filteredName._id, true),
      field
    );
  };

  return <Checkbox {...label} checked={checked} onChange={(e) => handleChange(e, field)} sx={{
    color: "#7ECEA7",           
    "&.Mui-checked": {
      color: "#183930",        
    },
  }} />;
};